<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-card-title>
      Card
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="desserts"
        class="elevation-1"
        :search="search"
        :actions="actions"
        dense
        :loading="loadingstatus"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        mobile-breakpoint="0"
        :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
        }"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }" v-if="item.status=='active'">
              <v-icon
                @click="cardDetails(item)"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                outlined
              >
                mdi-eye
              </v-icon>
            </template>
            <span>Card Details</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";
export default {
  data() {
    return {
      search: "",
      sortBy: "operation.name",
      sortDesc: false,

      loadingstatus: true,
      headers: [
        { text: "Card No", value: "card_no" },
        { text: "Card Type", value: "card_type.name" },
        { text: "CashBack", value: "card_type.cashback_amount" },
        { text: "Card Holder Name", value: "patient.patient_name" },
        { text: "Phone", value: "patient.patient_phone" },
        { text: "Address", value: "patient.patient_address" },
        { text: "Active Date", value: "active_date" },
        { text: "Status", value: "status" },
        { text: "Action", value: "actions" },
      ],
      actions: [
        {
          type: "edit",
          key: ["Description"],
          func: this.updatePayment,
          icon: "edit",
        },
      ],

      desserts: [],
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Patients",
          disabled: true,
          href: "patients",
        },
      ],
      returnUrl: atshq.defaults.headers.common.app_URL,
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      atshq
        .get("card/card")
        .then((response) => {
          // JSON responses are automatically parsed.
          this.desserts = response.data.data;
          this.loadingstatus = false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    getColor(status) {
      if (status == "open") return "orange";
      else return "green";
    },
    user_ledger(item) {
      var today = new Date();

      today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      window.open(
        this.returnUrl +
          "printdoc/invoice_list/" +
          this.date +
          "/" +
          item.user.id
      );
    },
    dateSelect(date) {
      this.loadingstatus = true;
      this.initialize(date);
    },
    cardDetails(item) {
      window.location.href = "card/details/" + item.card_no;
    },
  },
};
</script>